import * as React from 'react';
import {textConst} from '../../../constants/TextConst';
import shrink from '../../../images/shrink.png';

const ExpandCollapseIcon = ({isExpanded}) => {
    return (
        <div className="images plus-images">
            <img
                className={isExpanded ? 'shrink' : 'expand'}
                alt={textConst.expanShrinkAlt}
                src={shrink}
            />
            <img className="shrink" alt={textConst.expanShrinkAlt} src={shrink} />
        </div>
    );
};

export default ExpandCollapseIcon;
